module.exports = __webpack_public_path__ + "assets/img/smartTV-module4-6.acc633be.jpg";